import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { db } from '../../services/auth';
import Layout from './Layout';
import Home from './Home';
import About from './About';
import Vision from './Vision';
import Study from './Study';
import Contact from './Contact';
import Areas from './Areas';
import Users from './Users';

class Api extends React.Component {
	state = { website: {} };

	componentDidMount() {
		db.get('website').then(website => {
			console.log(website);
			this.setState({website});
		}).catch(console.log);
	}

	render(){
		var { website } = this.state;
		return (
			<pre style={{color: 'black'}}>{JSON.stringify(website, null, '  ')}</pre>
		);
	}
}

export default class Admin extends React.Component {
	state = { website: {}, loading: true, saving: false, files: {} };

	componentDidMount() {
		this.getData();
	}

	getData = () => {
		this.setState({loading: true});
		db.get('website').then(website => {
			console.log(website);
			this.setState({website, loading: false, files: {}});
		})
	}

	onChangeProp = (prop, value) => {
		var website = this.state.website;
		website[prop] = value;
		this.setState({website});
	}

	onChangeImage = (prop, file, dataURL) => {
		var { files, website } = this.state;
		files[prop] = file;
		website[prop] = dataURL;
		this.setState({files});
	};

	onChangeKey = (callback) => {
		var result = callback(this.state);
		if(result) this.setState({...result});
	};

	saveChanges = async () => {
		var { website, files } = this.state;
		this.setState({saving: true});
		var websiteData = { ...website };
		websiteData.websiteImage = [...website.websiteImage];
		delete websiteData.headerImageId;
		delete websiteData.signatureImageId;
		delete websiteData.studyImageId;
		websiteData.websiteImage.forEach(image => {
			if (image.imageId && image.imageId.length > 36) delete image.imageId;
		});
		websiteData.area.forEach(area => {
			if (area.imageId && area.imageId.length > 36) delete area.imageId;
		});
		websiteData.user.forEach(user => {
			if (user.imageId && user.imageId.length > 36) delete user.imageId;
		});
		try {
			var formData = [
				{name: 'website', value: JSON.stringify(websiteData)},
			];
			Object.keys(files).forEach(k => formData.push({name: k, value: files[k]}));
			var result = await db.postFormData('website', formData, { method: 'PUT', headers: { 'content-type': null } });
			console.log(result);
			this.setState({website: result, files: {}});
		} catch(err){
			alert(err);
		} finally {
			this.setState({saving: false});
		}
	}

	render(){
		console.log('aaaaaaaaaaaaaaaaa');
		var { match } = this.props;
		var { website, loading, saving } = this.state;
		var params = {
			website,
			onChangeKey: this.onChangeKey,
			onChangeProp: this.onChangeProp,
			onChangeImage: this.onChangeImage,
		};
		return (
			<Switch>
				<Layout onRestore={this.getData} saveChanges={this.saveChanges} match={match} website={website} loading={loading} saving={saving} >
					<Route exact path={`${match.url}/home`} render={props => <Home {...props} {...params} />} />
					<Route exact path={`${match.url}/about`} render={props => <About {...props} {...params} />} />
					<Route exact path={`${match.url}/vision`} render={props => <Vision {...props} {...params} />} />
					<Route exact path={`${match.url}/study`} render={props => <Study {...props} {...params} />} />
					<Route exact path={`${match.url}/contact`} render={props => <Contact {...props} {...params} />} />
					<Route exact path={`${match.url}/areas`} render={props => <Areas {...props} {...params} />} />
					<Route exact path={`${match.url}/professional`} render={props => <Users {...props} {...params} />} />
					<Route exact path={`${match.url}/`} render={_ => <Redirect to={`${match.url}/home`} />} />
				</Layout>
			</Switch>
		);
	}
}
